// extracted by mini-css-extract-plugin
export var infoRow = "_r2-2";
export var labelContainer = "_r2-0";
export var rightInfo = "_r2-1";